export default function selector(storeState) {
    return {
        profile: storeState.profile,
    };
}
